import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_BASE || '';

/**
 * The banner the office manages from the admin dashboard. Renders nothing at all
 * until a banner has been uploaded and switched on, so the page never reserves
 * empty space for it.
 */
export default function SiteBanner() {
  const [banner, setBanner] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    fetch(`${API_BASE}/api/site/banner`)
      .then((res) => (res.ok ? res.json() : { banner: null }))
      .then((data) => active && setBanner(data.banner))
      .catch(() => {});
    return () => { active = false; };
  }, []);

  if (!banner) return null;

  const internal = banner.ctaUrl?.startsWith('/');
  const hasText = banner.title || banner.subtitle || banner.ctaLabel;

  return (
    <section className={`site-banner ${loaded ? 'is-loaded' : ''}`}>
      <img
        src={`${API_BASE}${banner.imageUrl}`}
        alt={banner.altText || ''}
        onLoad={() => setLoaded(true)}
        loading="eager"
        style={{ objectPosition: banner.imageFocus || '50% 50%' }}
      />
      {hasText && (
        <div className="site-banner-overlay">
          <div className="shell">
            {banner.title && <h2>{banner.title}</h2>}
            {banner.subtitle && <p>{banner.subtitle}</p>}
            {banner.ctaLabel && banner.ctaUrl && (
              internal ? (
                <Link className="btn btn-primary" to={banner.ctaUrl}>{banner.ctaLabel}</Link>
              ) : (
                <a className="btn btn-primary" href={banner.ctaUrl} target="_blank" rel="noreferrer">
                  {banner.ctaLabel}
                </a>
              )
            )}
          </div>
        </div>
      )}
    </section>
  );
}
